import {
    createSelector
} from "reselect";

export const claimsSelector = createSelector(state => state && state.claims && state.claims.claims, claimsSelector => claimsSelector)
export const previewingClaimDataSelector = createSelector(state => state && state.claims && state.claims.previewingClaimData, previewingClaimDataSelector => previewingClaimDataSelector)
